<template>
  <v-row>
    <v-col
      cols="12"
      lg="2"
      md="4"
      sm="6"
      class="pt-2"
      v-for="link in sidebarLinks"
      :key="link.href"
      v-if="link.subtitle"
    >
      <v-card hover ripple :to="link.url">
        <v-card-text class="text-center">
          <v-icon x-large>{{ link.icon }}</v-icon>
          <h1 class="pt-4 title text--primary">
            {{ link.text }}
          </h1>
          <p class="text-subtitle-1 text--primary">
            {{ link.subtitle }}
          </p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  metaInfo() {
    return { title: "الرئيسية" };
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("SET_BREADCRUMBS", this.breadcrumbsItems);
  },
  computed: {
    ...mapState(["sidebarLinks"]),
    breadcrumbsItems() {
      return [{ text: "الرئيسية" }];
    },
  },
};
</script>
